export default "__VITE_ASSET__ac167492__"